import { __spreadArrays } from "tslib";
import { Bus } from "./bus/Bus";
import { defaultLogSink } from "./defaultLogSink";
import { WidgetContext } from "./context/WidgetContext";
export var WidgetLogLevelValues = {
    debug: 10,
    info: 20,
    warn: 30,
    error: 40,
};
var windowFetchBound = window.fetch.bind(window);
var GlobalWidgetConfiguration = /** @class */ (function () {
    function GlobalWidgetConfiguration(browserSupportsShadowDom) {
        this.__browserSupportsShadowDom = browserSupportsShadowDom;
        this.bus = new Bus();
        this.environment = "production";
        this.sharedCssUrls = [];
        this.__logSink = defaultLogSink;
        this.log = this.log.bind(this);
        this.logLevel = "info";
        this.widgets = {};
        this.context = new WidgetContext();
    }
    GlobalWidgetConfiguration.prototype.update = function (configuration) {
        this.environment = configuration.environment || this.environment;
        this.sharedCssUrls = configuration.sharedCssUrls || this.sharedCssUrls;
        this.__fetch = configuration.fetch || this.__fetch;
        this.__logSink = configuration.log || this.__logSink;
        this.logLevel = configuration.logLevel || this.logLevel;
        this.widgets = configuration.widgets || this.widgets;
        this.__neverUseShadowDom =
            configuration.neverUseShadowDom || this.__neverUseShadowDom;
    };
    GlobalWidgetConfiguration.prototype.log = function (widgetTagName, logLevel, message) {
        var optionalParams = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            optionalParams[_i - 3] = arguments[_i];
        }
        if (WidgetLogLevelValues[logLevel] >= WidgetLogLevelValues[this.logLevel]) {
            this.__logSink.apply(this, __spreadArrays([widgetTagName, logLevel, message], optionalParams));
        }
    };
    Object.defineProperty(GlobalWidgetConfiguration.prototype, "shadowDomSupported", {
        get: function () {
            return this.__browserSupportsShadowDom && this.__neverUseShadowDom !== true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalWidgetConfiguration.prototype, "fetch", {
        get: function () {
            return this.__fetch || windowFetchBound;
        },
        enumerable: false,
        configurable: true
    });
    return GlobalWidgetConfiguration;
}());
export { GlobalWidgetConfiguration };
